import { createApp, reactive, h } from 'vue';
import router from './router';
import App from './AppMain.vue';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Select from 'primevue/select';
import DatePicker from 'primevue/datepicker';
import Drawer from 'primevue/drawer';
import Editor from 'primevue/editor';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendarComponent from '@fullcalendar/vue3';

/** Compatibilidade com a API antiga do wrapper PrimeVue (props events + options). */
const FullCalendar = {
    name: 'FullCalendar',
    props: {
        events: Array,
        options: Object,
    },
    computed: {
        calendarOptions() {
            return {
                ...this.options,
                events: this.events ?? this.options?.events,
            };
        },
    },
    render() {
        return h(FullCalendarComponent, { options: this.calendarOptions });
    },
};
import Galleria from 'primevue/galleria';
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Knob from 'primevue/knob';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Popover from 'primevue/popover';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel';
import ScrollTop from 'primevue/scrolltop';
import Slider from 'primevue/slider';
import Skeleton from 'primevue/skeleton';
import SpeedDial from 'primevue/speeddial';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Steps from 'primevue/steps';
import StyleClass from 'primevue/styleclass';
import TabMenu from 'primevue/tabmenu';
import Tag from 'primevue/tag';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Timeline from 'primevue/timeline';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import { comDuracaoPadrao } from './shared/sebrae/toastDuracao';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';

import CodeHighlight from './AppCodeHighlight';
import BlockViewer from './BlockViewer';
import { primevueOptions } from './shared/primevue/primevueConfig';

import '@packages/design-system/style.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import './App.scss';
import './assets/demo/flags/flags.css';

// Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import store from './store/store';

// Moment Library
import moment from 'moment';
//Vue Mediaquery
import VueMq from 'vue3-mq';

//SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

//Numeral
import numeral from 'numeral';
// Componentes customizados
import ErrosBox from './shared/components/ErrosBoxComponent';
import MsgBox from './shared/components/MsgBoxComponent';
import LoadingBlockUI from './shared/components/LoadingBlockUIComponent';
import BtnRefresh from './shared/components/BtnRefreshComponent';
import Detalhe from './shared/components/DetalheComponent';
import Status from './shared/components/StatusComponent';
import BtnVoltar from './shared/components/BtnVoltarComponent';
import Painel from './shared/components/PainelComponent';
import { registerSebrae } from './shared/sebrae/register';
import BInput from './shared/components/inputs/BInput';
import BInputNumeric from './shared/components/inputs/BInputNumeric.vue';
import BInputMask from './shared/components/inputs/BInputMask';
import BDropdown from './shared/components/inputs/BDropdown';
import BCalendar from './shared/components/inputs/BCalendar';

// Bibliotecas customizados
import { temAcesso, temAcessoView } from '@/shared/auth/temAcesso';
import {
    queryPortalBootLoaderPaths,
    stopPortalMorphLoaderTimeline,
} from '@/shared/libs/portalMorphLoaderAnimation';
import masker from './shared/libs/mask/masker';
import download from './shared/libs/download';
import cpfMasker from './shared/libs/mask/cpfMasker';
import cnpjMasker from './shared/libs/mask/cnpjMasker';
import cpfCnpjMasker from './shared/libs/mask/cpfCnpjMasker';
import telefoneMasker from './shared/libs/mask/telefoneMasker';
import cepMasker from './shared/libs/mask/cepMasker';
import dateFormat, { formatarData, formatarDataHora, parseApiDateTime } from './shared/libs/dateTime';
import { validarCPF } from './shared/libs/cpf';
import { validarCNPJ } from './shared/libs/cnpj';
import { validarTelefone } from './shared/libs/telefone';
import './shared/libs/textoHelpers';
import isValidEmail from './shared/libs/is-valid-email';

library.add(fas);

moment.locale('pt-BR');

numeral.register('locale', 'pt-BR', {
    delimiters: {
        thousands: '.',
        decimal: ',',
    },
    currency: {
        symbol: 'R$ ',
    },
});
numeral.locale('pt-BR');

/** Aviso benigno do Chrome; evita overlay vermelho do webpack-dev-server. */
const RESIZE_OBSERVER_LOOP_RE = /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener(
    'error',
    (event) => {
        if (RESIZE_OBSERVER_LOOP_RE.test(event.message)) {
            event.stopImmediatePropagation();
        }
    },
    true
);

export const app = createApp(App);

app.config.globalProperties.$appState = reactive({ inputStyle: 'outlined' });
app.config.globalProperties.$primevue = reactive({ ripple: true });
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$temAcesso = temAcesso;
app.config.globalProperties.$temAcessoView = temAcessoView;
app.config.globalProperties.$masker = masker;
app.config.globalProperties.$toCpf = cpfMasker;
app.config.globalProperties.$toCnpj = cnpjMasker;
app.config.globalProperties.$toCpfCnpj = cpfCnpjMasker;
app.config.globalProperties.$toTel = telefoneMasker;
app.config.globalProperties.$toCep = cepMasker;
app.config.globalProperties.$validarCPF = validarCPF;
app.config.globalProperties.$validarCNPJ = validarCNPJ;
app.config.globalProperties.$validarTelefone = validarTelefone;
app.config.globalProperties.$validarEmail = isValidEmail;
app.config.globalProperties.$dateFormat = dateFormat;
app.config.globalProperties.$formatarData = formatarData;
app.config.globalProperties.$formatarDataHora = formatarDataHora;
app.config.globalProperties.$parseApiDateTime = parseApiDateTime;
app.config.globalProperties.$download = download;
app.config.globalProperties.$numeral = numeral;

app.use(PrimeVue, primevueOptions);

app.use(ConfirmationService);
app.use(ToastService);

/*
 * Duração padrão dos toasts em um lugar só. O ToastService registra o MESMO objeto em
 * `globalProperties.$toast` e no `provide` do `useToast()`, então envolver o `add` aqui
 * cobre os dois estilos de chamada. Sem isso, uma mensagem sem `life` nunca fecha: o
 * PrimeVue só inicia o temporizador `if (message.life)`.
 */
const servicoToast = app.config.globalProperties.$toast;
const adicionarToastOriginal = servicoToast.add.bind(servicoToast);
servicoToast.add = (mensagem) => adicionarToastOriginal(comDuracaoPadrao(mensagem));

app.use(router);

app.use(store);

app.use(VueMq, {
    breakpoints: {
        sm: 576,
        md: 768,
        lg: 992,
        xl: Infinity,
    },
});

app.use(VueSweetalert2);

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
app.directive('code', CodeHighlight);
app.directive('badge', BadgeDirective);
app.directive('styleclass', StyleClass);

app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Breadcrumb', Breadcrumb);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Carousel', Carousel);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ContextMenu', ContextMenu);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('Select', Select);
app.component('DatePicker', DatePicker);
app.component('Editor', Editor);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('FullCalendar', FullCalendar);
app.component('Galleria', Galleria);
app.component('Image', Image);
app.component('InlineMessage', InlineMessage);
app.component('Inplace', Inplace);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('IconField', IconField);
app.component('InputIcon', InputIcon);
app.component('Knob', Knob);
app.component('Listbox', Listbox);
app.component('MegaMenu', MegaMenu);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('OrderList', OrderList);
app.component('OrganizationChart', OrganizationChart);
app.component('OverlayPanel', OverlayPanel);
app.component('Popover', Popover);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
app.component('PickList', PickList);
app.component('ProgressBar', ProgressBar);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('SelectButton', SelectButton);
app.component('ScrollPanel', ScrollPanel);
app.component('ScrollTop', ScrollTop);
app.component('Slider', Slider);
app.component('Drawer', Drawer);
app.component('Skeleton', Skeleton);
app.component('SpeedDial', SpeedDial);
app.component('SplitButton', SplitButton);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('Steps', Steps);
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('TieredMenu', TieredMenu);
app.component('Timeline', Timeline);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);

app.component('BlockViewer', BlockViewer);

app.component('ErrosBox', ErrosBox);
app.component('MsgBox', MsgBox);
app.component('LoadingBlockUi', LoadingBlockUI);
app.component('BtnRefresh', BtnRefresh);
app.component('Detalhe', Detalhe);
app.component('Status', Status);
app.component('BtnVoltar', BtnVoltar);
app.component('Painel', Painel);
app.component('BInput', BInput);
app.component('BInputNumeric', BInputNumeric);
app.component('BInputMask', BInputMask);
app.component('BDropdown', BDropdown);
app.component('BCalendar', BCalendar);

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);
app.component('font-awesome-layers-text', FontAwesomeLayersText);

registerSebrae(app);

app.mount('#app');

const bootLoaderTimeline = window.__portalBootLoaderTimeline;
const bootLoaderPaths = queryPortalBootLoaderPaths();
if (bootLoaderTimeline || bootLoaderPaths?.symbolPath) {
    stopPortalMorphLoaderTimeline(bootLoaderTimeline, bootLoaderPaths);
    window.__portalBootLoaderTimeline = null;
}
